<ng-container [ngSwitch]="question?.type">
    <app-question-selection-component *ngSwitchCase="questionType.Selection" [group]="group.get(question.id)" [question]="question">
    </app-question-selection-component>
    <app-question-score-component *ngSwitchCase="questionType.Score" [group]="group.get(question.id)" [question]="question">
    </app-question-score-component>
    <app-question-contact-person-component
        *ngSwitchCase="questionType.ContactPerson"
        [group]="group"
        [question]="question"
    >
    </app-question-contact-person-component>
    <app-question-free-text-component *ngSwitchCase="questionType.FreeText" [group]="group.get(question.id)" [question]="question">
    </app-question-free-text-component>
    <smvd-shared-question-text *ngSwitchCase="questionType.Text" [group]="group.get(question.id)" [question]="question">
    </smvd-shared-question-text>
    <smvd-shared-question-address
        *ngSwitchCase="questionType.Address"
        [group]="group.get(question.id)"
        [question]="question"
    ></smvd-shared-question-address>
</ng-container>
